var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropofflocationcomponent = function SvgDropofflocationcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.833c0-2.206-1.793-4-4-4s-4 1.794-4 4c0 3 4 7.334 4 7.334s4-4.334 4-7.334Zm-5.333 0C6.667 5.1 7.267 4.5 8 4.5s1.333.6 1.333 1.333a1.333 1.333 0 1 1-2.666 0Zm-3.334 9.334v-1.334h9.334v1.334H3.333Z",
    fill: "current"
  })));
};
export default SvgDropofflocationcomponent;